export function MicrosoftLogo({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.4 3H3v8.4h8.4V3z" fill="#F25022" />
      <path d="M11.4 12.6H3V21h8.4v-8.4z" fill="#00A4EF" />
      <path d="M21 3h-8.4v8.4H21V3z" fill="#7FBA00" />
      <path d="M21 12.6h-8.4V21H21v-8.4z" fill="#FFB900" />
    </svg>
  );
}
